/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1DocumentModel } from '../../entities/v1/DocumentModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1DocumentDataStatusStringSchema } from './documentDataStatusStringSchema'
import { v1DocumentObjectStringSchema } from './documentObjectStringSchema'
import { z } from 'zod'

export const v1DocumentModelSchema = z.object({
  document_data_comment: z.string(),
  document_data_id: z.number().int(),
  document_data_reason_text: z.string(),
  document_data_status: z.lazy(() => v1DocumentDataStatusStringSchema),
  document_data_value: z.string(),
  document_id: z.number().int(),
  document_is_enabled: z.boolean(),
  document_object_additional_text: z.string(),
  document_object_codename: z.string(),
  document_object_description: z.string(),
  document_object_id: z.number().int(),
  document_object_is_enabled: z.boolean(),
  document_object_is_filled: z.boolean(),
  document_object_is_hidden: z.boolean(),
  document_object_is_required: z.boolean(),
  document_object_optional_label: z.string(),
  document_object_options: z.string(),
  document_object_placeholder: z.string(),
  document_object_sort: z.number().int(),
  document_object_text_max_length: z.number().int(),
  document_object_text_min_length: z.number().int(),
  document_object_type: z.lazy(() => v1DocumentObjectStringSchema),
  document_sort: z.number().int(),
  title: z.string(),
}) as unknown as ToZod<V1DocumentModel>